import type { Widget } from "../types/widget";

export function resolveGroupByField(widget?: Widget): string | undefined {
  const mapping = widget?.output?.mapping;
  if (!mapping || typeof mapping !== "object") {
    return undefined;
  }
  const m = mapping as Record<string, unknown>;
  const explicit = m.groupByField ?? m.dimensionField ?? m.groupBy;
  if (typeof explicit === "string" && explicit.trim()) {
    return explicit.trim();
  }
  return undefined;
}

export function resolveGroupByFieldOrDefault(widget?: Widget, fallback = "state"): string {
  return resolveGroupByField(widget) || fallback;
}
